import { observable, toJS } from "mobx";
import moment from "moment";

export const store = observable({

  // filtering
  activeFilters: ["Content"],
  filterContent: null,
  filterStartDate: null,
  filterEndDate: null,
  filterChannel: null,
  filterAgent: null,
  selectedTab: 'campaign'
});






// WEBPACK FOOTER //
// ./src/module-email-campaign/store.js